import React, { ReactNode } from 'react'
import { IllustrationName, IllustrationProps } from './Illustration.types'

import styles from './Illustration.styles.scss'

import GrinningSunLight from './assets/GrinningSunLight.svg'
import GrinningSunDark from './assets/GrinningSunDark.svg'
import AvocadoLight from './assets/AvocadoLight.svg'
import BabyBalloonsLight from './assets/BabyBalloonsLight.svg'
import BirthdayCupcakeLight from './assets/BirthdayCupcakeLight.svg'
import BunInTheOvenLight from './assets/BunInTheOvenLight.svg'
import CrayonsLight from './assets/CrayonsLight.svg'
import FlowerSmileLight from './assets/FlowerSmileLight.svg'
import FlowerSunglassesLight from './assets/FlowerSunglassesLight.svg'
import GameControllerLight from './assets/GameControllerLight.svg'
import GreenSmileLight from './assets/GreenSmileLight.svg'
import HeartPuzzleLight from './assets/HeartPuzzleLight.svg'
import MeltingSmileLight from './assets/MeltingSmileLight.svg'
import ShootingStarLight from './assets/ShootingStarLight.svg'
import ThumbsDownLight from './assets/ThumbsDownLight.svg'
import ThumbsUpLight from './assets/ThumbsUpLight.svg'
import UpsideDownSmileLight from './assets/UpsideDownSmileLight.svg'
import AvocadoDark from './assets/AvocadoDark.svg'
import BabyBalloonsDark from './assets/BabyBalloonsDark.svg'
import BirthdayCupcakeDark from './assets/BirthdayCupcakeDark.svg'
import BunInTheOvenDark from './assets/BunInTheOvenDark.svg'
import CrayonsDark from './assets/CrayonsDark.svg'
import FlowerSmileDark from './assets/FlowerSmileDark.svg'
import FlowerSunglassesDark from './assets/FlowerSunglassesDark.svg'
import GameControllerDark from './assets/GameControllerDark.svg'
import GreenSmileDark from './assets/GreenSmileDark.svg'
import HeartPuzzleDark from './assets/HeartPuzzleDark.svg'
import MeltingSmileDark from './assets/MeltingSmileDark.svg'
import ShootingStarDark from './assets/ShootingStarDark.svg'
import ThumbsDownDark from './assets/ThumbsDownDark.svg'
import ThumbsUpDark from './assets/ThumbsUpDark.svg'
import UpsideDownSmileDark from './assets/UpsideDownSmileDark.svg'

const Illustration: React.FC<IllustrationProps> = ({
  variant = 'light',
  name,
}) => {
  const lightModeComponentMapping: Record<IllustrationName, ReactNode> = {
    Avocado: <AvocadoLight />,
    BabyBalloons: <BabyBalloonsLight />,
    BirthdayCupcake: <BirthdayCupcakeLight />,
    BunInTheOven: <BunInTheOvenLight />,
    Crayons: <CrayonsLight />,
    FlowerSmile: <FlowerSmileLight />,
    FlowerSunglasses: <FlowerSunglassesLight />,
    GameController: <GameControllerLight />,
    GreenSmile: <GreenSmileLight />,
    GrinningSun: <GrinningSunLight />,
    HeartPuzzle: <HeartPuzzleLight />,
    MeltingSmile: <MeltingSmileLight />,
    ShootingStar: <ShootingStarLight />,
    ThumbsDown: <ThumbsDownLight />,
    ThumbsUp: <ThumbsUpLight />,
    UpsideDownSmile: <UpsideDownSmileLight />,
  }

  const darkModeComponentMapping: Record<IllustrationName, ReactNode> = {
    Avocado: <AvocadoDark />,
    BabyBalloons: <BabyBalloonsDark />,
    BirthdayCupcake: <BirthdayCupcakeDark />,
    BunInTheOven: <BunInTheOvenDark />,
    Crayons: <CrayonsDark />,
    FlowerSmile: <FlowerSmileDark />,
    FlowerSunglasses: <FlowerSunglassesDark />,
    GameController: <GameControllerDark />,
    GreenSmile: <GreenSmileDark />,
    GrinningSun: <GrinningSunDark />,
    HeartPuzzle: <HeartPuzzleDark />,
    MeltingSmile: <MeltingSmileDark />,
    ShootingStar: <ShootingStarDark />,
    ThumbsDown: <ThumbsDownDark />,
    ThumbsUp: <ThumbsUpDark />,
    UpsideDownSmile: <UpsideDownSmileDark />,
  }

  return (
    <div className={styles.Illustration} data-testid="Illustration">
      {variant === 'light'
        ? lightModeComponentMapping[name]
        : darkModeComponentMapping[name]}
    </div>
  )
}

export default Illustration
